import React from 'react';
import {View, Text} from 'react-native';
import styles from '../../style/costCalculator';

/**
 * Pure presentational header used at the top of every calculator section (and, with
 * `size="sub"`, every subsection nested inside "Tangible Costs"). Gives each section a
 * numbered badge + title + one-line "what this is for" description so it reads as a
 * distinct step rather than an inline bold label. No state, no calculation logic —
 * purely a design-pass addition alongside the pre-existing, functionally-verified screen.
 */
const SectionHeader = ({number, title, description, size = 'main'}) => {
  const isSub = size === 'sub';
  return (
    <View style={[styles.sectionHeaderRow, isSub && styles.subsectionHeaderRow]}>
      <View style={[styles.sectionBadge, isSub && styles.subsectionBadge]}>
        <Text style={[styles.sectionBadgeText, isSub && styles.subsectionBadgeText]}>
          {number}
        </Text>
      </View>
      <View style={styles.sectionHeaderText}>
        <Text style={[styles.sectionTitle, isSub && styles.subsectionTitle]}>{title}</Text>
        {description ? (
          <Text style={[styles.sectionDescription, isSub && styles.subsectionDescription]}>
            {description}
          </Text>
        ) : null}
      </View>
    </View>
  );
};

export default SectionHeader;
